import { render, staticRenderFns } from "./OrderDetailStats.vue?vue&type=template&id=b94ca9d6&scoped=true"
import script from "./OrderDetailStats.vue?vue&type=script&lang=js"
export * from "./OrderDetailStats.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailStats.vue?vue&type=style&index=0&id=b94ca9d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94ca9d6",
  null
  
)

export default component.exports